export const HEADERS = [
	'No.',
	'Consultant',
	'Score',
	'Path',
	'Status',
	'Review',
	'Critical',
	'Analyzed at',
	'Actions',
];
